import { Controller } from "@hotwired/stimulus"
import { NavigationHelper } from "~/helpers/navigation_helper"

export default class extends Controller {
  static targets = ["container", "loader"]

  static values = { type: String, id: Number }

  connect() {
    // in case the user is on a Turbo preview of the page,
    // don't fetch the preview
    if (NavigationHelper.pageIsPreview()) {
      return
    }

    this.load()
  }

  load() {
    fetch(`/${this.typeValue}/${this.idValue}/preview`, {
      credentials: "same-origin",
    })
      .then((response) => response.text())
      .then((html) => {
        this.containerTarget.innerHTML = html
        this.loaderTarget.style.display = "none"
      })
  }
}
